import { createApp } from 'vue';
import shindanSlideForm from '@/javascripts/components/shindan/shindan_slide_box.vue';

const app = createApp(shindanSlideForm);
app.mount('#app');
